// Valores iniciales del panel de detalle: la promo nueva arranca hoy con 30 días de vigencia.
import { emptySalePromotionForm, type SalePromotionFormValues } from './salePromotionForm';

/** Suma días a un día de calendario `YYYY-MM-DD`, sin pasar por zonas horarias. */
export function addDaysToDay(day: string, days: number): string {
    const date = new Date(`${day}T00:00:00Z`);
    date.setUTCDate(date.getUTCDate() + days);
    return date.toISOString().slice(0, 10);
}

export const NEW_PROMOTION_DAYS = 30;

/** `skus` llega de «Crear promo venta» en Inventario. */
export function newPromotionFormValues(
    today: string,
    skus: string[] = [],
): SalePromotionFormValues {
    return {
        ...emptySalePromotionForm(),
        skus,
        validFrom: today,
        validUntil: addDaysToDay(today, NEW_PROMOTION_DAYS),
    };
}
